import { getModifiers } from '@helpers/functions';
import { SectionHeadingModel } from '@_types/types';
import Button from '@atoms/buttons/Button';
import { createElement, ReactNode } from 'react';

type Props = {
  children?: ReactNode;
} & SectionHeadingModel;

const SectionHeading = (model: Props) => {
  const { heading, subHeading, buttonLink, textLink, headingLevel, children, persistDesktopButtons, id } = model;
  const styleModifiers = getModifiers(model, 'kf-m-section-heading');

  const buttonContainer = (className: string = '') => {
    return (
      <div className={`kf-m-section-heading__buttons-container ${className}`}>
        {textLink && (
          <Button
            href={textLink.url}
            link={true}
            styleModifier={['tertiary', 'bold', textLink?.styleModifier?.includes('large') ? 'large' : 'small', 'text-center']}
            target={textLink.target}
            text={textLink.text}
          />
        )}
        {buttonLink && (
          <Button
            href={buttonLink.url}
            link={true}
            styleModifier={['secondary', 'bold', 'small', 'text-center']}
            target={buttonLink.target}
            text={buttonLink.text}
          />
        )}
      </div>
    );
  };

  return (
    <div className={styleModifiers} data-persist-desktop-buttons={persistDesktopButtons} id={id}>
      <div className="kf-m-section-heading__heading-container">
        <div className="kf-m-section-heading__text-container">
          {createElement(headingLevel ?? 'h2', { className: 'kf-m-section-heading__heading' }, heading)}
          {subHeading && <p className="kf-m-section-heading__sub-heading">{subHeading}</p>}
        </div>
        {buttonLink && buttonContainer('kf-m-section-heading__buttons-container--desktop')}
      </div>
      {children}

      {buttonLink && buttonContainer('kf-m-section-heading__buttons-container--mobile')}
    </div>
  );
};

export { SectionHeading };
